import { Button } from "@/components/ui/button";

interface NotificationPermissionAlertProps {
  permissionStatus: NotificationPermission;
  onRequestPermission: () => void;
}

const NotificationPermissionAlert = ({ 
  permissionStatus, 
  onRequestPermission 
}: NotificationPermissionAlertProps) => {
  if (permissionStatus === 'granted') return null;

  return (
    <div className="p-4 bg-muted rounded-lg" data-testid="notification-permission-alert">
      <p className="text-sm text-muted-foreground mb-3" data-testid="notification-message">
        {permissionStatus === 'denied' 
          ? "Notifications are blocked. Please enable them in your browser settings."
          : "Enable push notifications to receive alerts and updates."
        }
      </p>
      {permissionStatus === 'default' && (
        <Button onClick={onRequestPermission} size="sm" data-testid="enable-notifications-button">
          Enable Notifications
        </Button>
      )}
    </div>
  );
};

export default NotificationPermissionAlert;